/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var GetNotes = require('../services/GetNotes');
var GetAllNoteLookups = require('../services/GetAllNoteLookups');
var SubmitNoteUpdate = require('../services/SubmitNoteUpdate');
var NotesView = require('../views/NotesView');

module.exports = {
  channel: 'sc',

  event: 'build:notes-view',

  builder: function(data) {
    return new PlaceholderView({
      viewPromise: buildNotesView(data)
    });
  }
};

function buildNotesView(data) {
  var deferred = $.Deferred();

  $.when(GetNotes({ objectId: data.objectId, objectTypeId: data.objectTypeId }), GetAllNoteLookups())
    .done(function(notes, noteTypes) {
      deferred.resolve(
        new NotesView({
          submitNoteService: SubmitNoteUpdate,
          managerRole: 'SC - Manager',
          model: new Backbone.Model({
            objectId: data.objectId,
            objectTypeId: data.objectTypeId,
            notes: notes,
            noteTypes: noteTypes
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
}
